<template>
  <Form
    :initial-values="initialValues"
    class="flex flex-col gap-3"
    v-slot="{ values, setFieldValue, resetField }"
    @submit="(values) => $emit('onSubmitNewAddress', values)"
  >
    <div class="flex flex-col md:flex-row">
      <Field
        :rules="requiredRule"
        name="deliveryMethodId"
        v-slot="{ field, errors: errs, handleChange }"
      >
        <Dropdown
          :field="field"
          :errors="errs"
          :label="$t('deliveryMethod')"
          :options="addressMgmtStore.deliveryMethods"
          :is-read-only="isReadOnly"
          :disabled="disabledFields?.includes(field.name)"
          class="px-0.5 w-full md:w-1/2"
          direction="flex-col"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('postalBranchId')
              onDeliveryMethodChange(values, setFieldValue, resetField)
            }
          "
        ></Dropdown>
      </Field>
      <Field
        :rules="requiredRule"
        name="deliveryCompanyId"
        v-slot="{ field, errors: errs, handleChange }"
      >
        <Dropdown
          :field="field"
          :errors="errs"
          :label="$t('deliveryCompany')"
          :options="addressMgmtStore.deliveryCompanies"
          :is-read-only="isReadOnly"
          :disabled="disableDeliveryCompany || disabledFields?.includes(field.name)"
          class="px-0.5 w-full md:w-1/2"
          direction="flex-col"
          @on-selection="
            (item) => {
              handleChange(+item?.id)
              resetField('postalBranchId')
              onDeliveryCompanyChange(values)
            }
          "
        ></Dropdown>
      </Field>
    </div>

    <TawzeaForm
      v-if="values.deliveryCompanyId == 2"
      :values
      :isReadOnly
      :setFieldValue
      :resetField
    ></TawzeaForm>
    <EmipostForm
      v-if="values.deliveryCompanyId == 1"
      :values
      :isReadOnly
      :setFieldValue
      :resetField
    ></EmipostForm>

    <div v-if="!isReadOnly" class="w-full flex justify-between">
      <button
        class="text-center rounded-md bg-brand-gray-600/80 hover:bg-brand-gray-600 flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        @click="$emit('onCancel')"
      >
        <div class="p-2 bg-brand-gray-600 rounded-s-md">
          <faTimes class="w-4 fill-white"></faTimes>
        </div>
        <span class="w-full text-center">
          {{ $t('Cancel') }}
        </span>
        <div class="p-0.5"></div>
      </button>
      <button
        class="min-w-28 text-center rounded-md bg-primary/80 pe-2 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
      >
        <div class="p-2 bg-primary rounded-s-md">
          <faDiskette class="w-4 fill-white"></faDiskette>
        </div>
        <span class="w-full text-center">
          {{ $t('Save') }}
        </span>
      </button>
    </div>
  </Form>
</template>

<script setup>
import faTimes from '@/assets/icons/faTimes.svg?component'
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import Dropdown from '@/components/SimpleForm/Dropdown.vue'
import { useIndAddressMgmtStore } from '@/stores/ind_address_mgmt.js'
import EmipostForm from '@/views/auth-user/addresses/Modal/NewDeliveryAddress/_EmipostForm.vue'
import TawzeaForm from '@/views/auth-user/addresses/Modal/NewDeliveryAddress/_TawzeaForm.vue'
import { Field, Form } from 'vee-validate'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()
const addressMgmtStore = useIndAddressMgmtStore()

const disableDeliveryCompany = ref(false)

defineProps({
  isReadOnly: Boolean,
  initialValues: {
    type: Object,
    default: () => {
      return {
        mobileNumber: '00971',
        phoneNumber: '00971',
        poBoxFlag: 0
      }
    }
  },
  disabledFields: Array
})

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

async function onDeliveryMethodChange(form, setFieldValue, resetField) {
  disableDeliveryCompany.value = false
  resetField('deliveryCompanyId')

  if (form.deliveryMethodId === 2) {
    disableDeliveryCompany.value = true
    setFieldValue('deliveryCompanyId', 2)
  }

  await fetchDeliveryDetails(form)
}

async function onDeliveryCompanyChange(form) {
  await fetchDeliveryDetails(form)
}

async function fetchDeliveryDetails(form) {
  const { deliveryMethodId, deliveryCompanyId } = form
  if ([deliveryMethodId, deliveryCompanyId].some((d) => !d)) return
  await addressMgmtStore.fetchDeliveryDetails(deliveryMethodId, deliveryCompanyId)
}
</script>

<style lang="scss" scoped></style>
